import interact from 'interactjs'

let waters = null
let airs = null
let earths = null
let fires = null

let waterImage = null
let airImage = null
let earthImage = null
let fireImage = null

let elements = []

export default function initDragDrop () {
  waters = document.querySelectorAll('.water')
  airs = document.querySelectorAll('.air')
  earths = document.querySelectorAll('.earth')
  fires = document.querySelectorAll('.fire')

  waterImage = require('@/assets/water.jpg')
  airImage = require('@/assets/air.jpg')
  earthImage = require('@/assets/earth.jpg')
  fireImage = require('@/assets/fire.jpg')

  elements = [
    ...waters,
    ...airs,
    ...earths,
    ...fires
  ]

  for (const water of waters) {
    water.style.backgroundImage = `url(${waterImage})`
  }
  for (const air of airs) {
    air.style.backgroundImage = `url(${airImage})`
  }
  for (const earth of earths) {
    earth.style.backgroundImage = `url(${earthImage})`
  }
  for (const fire of fires) {
    fire.style.backgroundImage = `url(${fireImage})`
  }

  for (const element of elements) {
    const position = { x: 0, y: 0 }
    interact(`#${element.id}`).draggable({
      listeners: {
        start (event) {
          event.target.classList.remove('elementTransition')
          event.target.style.zIndex = '10'
        },
        move (event) {
          position.x += event.dx
          position.y += event.dy
          event.target.style.transform = `translate(${position.x}px, ${position.y}px)`
        },
        end (event) {
          event.target.classList.add('elementTransition')
          if (!event.dropzone) {
            event.target.style.transform = 'translate(0px, 0px)'
          }
          event.target.style.zIndex = 'initial'
          position.x = 0
          position.y = 0
        }
      }
    })
  }
}
